<template>
  <div>
    <EventInstitutionGroup :callbackSelect="selectGroup"></EventInstitutionGroup>
    <div class="d-flex my-3">
      <v-spacer></v-spacer>
      <div class="pr-2">
        <v-text-field v-model="bSize" label="Batch Size" required></v-text-field>
      </div>

      <div class="pr-2">
        <v-text-field v-model="bNumber" label="Batch Number" required></v-text-field>
      </div>
      <JsonExcel ref="jsonExcel" :key="reportKey" :name='reportName' worksheet="Hamochi" :data="printData">
        <v-btn color="primary" :loading="apiDownload.isLoading" dark @click="downloadExcel">
          Download Excel
        </v-btn>
      </JsonExcel>
    </div>
    <div v-if="!api.isLoading && isPaginated" ref="printMe">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">#</th>
              <th class="text-left">Event Player ID</th>
              <th class="text-left">Event Finisher ID</th>
               <th class="text-left">Mochi ID</th>
              <th class="text-left">School Year</th>
              <!-- <th class="text-left">Ranking</th> -->
              <th class="text-left">School Name</th>
              <th class="text-left">Classroom Name</th>
              <th class="text-left">Main School Name</th>
               <th class="text-left">Main Classroom Name</th>
              <th class="text-left">Student Name</th>
              <th class="text-left">Gender</th>
              <th class="text-left">Race</th>
              <th class="text-left">NRIC/Passport No</th>
              <th class="text-left">Email Address (MOE Email)</th>
              <th class="text-left">Total Attempts</th>
              <th class="text-left">Total Submissions</th>
              <th class="text-left">Total Score</th>
              <th class="text-left">Total Stars</th>
              <!-- <th class="text-left">Involvement</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, a) in data" :key="item.id">
              <td>{{ a + 1 }}</td>
              <td>{{ item.id }}</td>
               <td><span v-if="item.Finisher">{{ item.Finisher.id }}</span>
                <span v-else>-</span>
              </td>
              <td>{{ item.mochiId }}</td>
              <td>{{ item.Classroom && item.Classroom.schoolYear ? item.Classroom.schoolYear : "N/A" }}</td>
              <!-- <td>{{ item.rank }}</td> -->
              <td>{{ item.Institution && item.Institution.name ? item.Institution.name.toUpperCase() : "N/A" }}</td>
              <td>{{ item.Classroom && item.Classroom.name ? item.Classroom.name.toUpperCase() : "N/A" }}</td>
               <td>{{ item.mainInstitution ? item.mainInstitution.toUpperCase() : "N/A" }}</td>
              <td>{{ item.mainClassroom ? item.mainClassroom.toUpperCase() : "N/A" }}</td>
              <td>{{ item.name ? item.name.toUpperCase() : "N/A" }}</td>
              <td>
                <span v-if="item.gender && item.gender == 'other' && item.originalGender && item.originalGender != ''">{{
                  item.originalGender.toUpperCase()
                }}</span><span v-else-if="item.gender && item.gender != ''">{{ item.gender.toUpperCase() }}</span>
                <span v-else>-</span>
              </td>
              <td>
                <span v-if="item.race && item.race == 'other' && item.originalRace && item.originalRace != ''">{{
                  item.originalRace.toUpperCase()
                }}</span><span v-else-if="item.race && item.race != ''">{{ item.race.toUpperCase() }}</span>
                <span v-else>-</span>
              </td>
              <td><span v-if="item.email && item.email != ''">{{ item.email }}</span>
                <span v-else>-</span>
              </td>
              <td><span v-if="item.moeNumber && item.moeNumber != ''">{{ item.moeNumber.toUpperCase() }}</span>
                <span v-else>-</span>
              </td>
              <td>{{ item.totalAttempt }}</td>
              <td>{{ item.totalSubmission }}</td>
              <td>{{ item.totalScore }}</td>
              <td>{{ item.totalStar }}</td>
              <!-- <td>{{ item.involvement }}%</td> -->
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <div class="text-center" v-if="!api.isLoading">
      <v-container>
        <v-row justify="center">
          <v-col cols="8">
            <v-container class="max-width">
              <v-pagination v-model="page" class="my-4" :length="totalPages"></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- BOC:[loader] -->
    <ALoader :isLoading="api.isLoading"></ALoader>
    <!-- EOC -->
  </div>
</template>

<script>
import { mapState } from "vuex";

import JsonExcel from "vue-json-excel";
//BOC: [print]
import VueHtml2Canvas from "vue-html2canvas";
import Vue from "vue";
import EventInstitutionGroup from "./EventInstitutionGroup.vue";
Vue.use(VueHtml2Canvas);
//EOC
export default {
  components: {
    EventInstitutionGroup,
    JsonExcel,
  },
  computed: mapState({
    //
  }),
  props: ["eventCode"],
  data: () => ({
    reportKey: 0,
    data: [],
    printData: [],
    groupId: null,
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    //BOC:[api]
    apiDownload: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    loading: false,
    //BOC:[pagination]
    page: 1,
    totalPages: 5,
    limit: 10,
    isLoading: false,
    isPaginated: true,
    bSize: 1000,
    bNumber: 1,
    reportName: '',
    //EOC
  }),
  created() { },
  watch: {
    page: function () {
      this.fetch();
    },
  },
  mounted() { },
  methods: {
    selectGroup(val) {
      this.groupId = val;
      this.fetch();
    },
    fetch() {
      this.isLoading = true;
      //BOC:[api]
      this.api.method = "get";
      this.api.url = `${this.$api.servers.event}/api/v1/en/moderator/event/${this.$route.params.id}/institutionGroup/${this.groupId}/report?limit=${this.limit}&page=${this.page}&isPaginated=${this.isPaginated}`;
      this.api.callbackReset = () => {
        this.api.isLoading = true;
        this.api.isError = false;
      };
      this.api.callbackError = (e) => {
        this.api.isLoading = false;
        this.api.isError = true;
        this.api.error = e;
      };
      this.api.callbackSuccess = (resp) => {
        this.data = resp.data;
        this.isLoading = false;
        this.api.isLoading = false;
        this.page = resp.page;
        this.totalPages = resp.totalPages;
      };
      //EOC
      this.$api.fetch(this.api);
    },
    async downloadExcel() {
      this.apiDownload.isLoading = true;
      this.reportKey++;
      
      // Fetch all data
      this.apiDownload.method = "get";
      this.apiDownload.url = `${this.$api.servers.event}/api/v1/en/moderator/event/${this.$route.params.id}/institutionGroup/${this.groupId}/report?limit=${this.bSize}&page=${this.bNumber}&isPaginated=true`;

      this.apiDownload.callbackReset = () => {
        this.apiDownload.isLoading = true;
        this.apiDownload.isError = false;
      };

      this.apiDownload.callbackError = (e) => {
        this.apiDownload.isLoading = false;
        this.apiDownload.isError = true;
        this.apiDownload.error = e;
      };

      this.apiDownload.callbackSuccess = (resp) => {
        try {
          const allData = resp.data;
          this.printData = []
          this.reportName = `report_size_${this.bSize}_batch_${this.bNumber}.xls`

          this.printData = allData.map((obj, index) => {
            return {
              'No': index + 1 + (this.bNumber - 1) * this.bSize,
              'Event Player ID': obj.id,
              'Event Finisher ID': obj.Finisher ? obj.Finisher.id:'N/A',
              'Mochi ID': obj.mochiId? obj.mochiId : "N/A",
              'School Year': obj.Classroom && obj.Classroom.schoolYear ? obj.Classroom.schoolYear : "N/A",
              // 'Ranking': obj.rank,
              'School Name': obj.Institution && obj.Institution.name ? obj.Institution.name.toUpperCase() : "N/A",
              'Classroom Name': obj.Classroom && obj.Classroom.name ? obj.Classroom.name.toUpperCase() : "N/A",
              'Main School Name': obj.mainInstitution ? obj.mainInstitution.toUpperCase() : "N/A",
              'Main Classroom Name': obj.mainClassroom ? obj.mainClassroom.toUpperCase() : "N/A",
              'Student Name': obj.name ? obj.name.toUpperCase() : "N/A",
              'Gender': obj.gender === 'other' && obj.originalGender && obj.originalGender != '' ? obj.originalGender.toUpperCase() : obj.gender && obj.gender != '' ? obj.gender.toUpperCase() : "N/A",
              'Race': obj.race === 'other' && obj.originalRace && obj.originalRace != '' ? obj.originalRace.toUpperCase() : obj.race && obj.race != '' ? obj.race.toUpperCase() : "N/A",
              'NRIC/Passport No': obj.moeNumber && obj.moeNumber != '' ? obj.moeNumber.toUpperCase() : "N/A",
              'Email Address (MOE Email)': obj.email && obj.email != '' ? obj.email.toUpperCase() : "N/A",
              'Total Attempts': obj.totalAttempt,
              'Total Submissions': obj.totalSubmission,
              'Total Score': obj.totalScore,
              'Total Stars': obj.totalStar,
              // 'Involvement(%)': obj.involvement,
            };
          });

          this.$nextTick(() => {
            if (this.printData.length && this.$refs.jsonExcel) {
              setTimeout(() => {
                this.$refs.jsonExcel.generate();
              }, 200);
            }
          });
        }
        catch (e) {
          console.log(e);
        }
        finally {
          this.apiDownload.isLoading = false;
        }
      };

      this.$api.fetch(this.apiDownload);
    },
  },
};
</script>